import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { BrowserService } from 'app/core/browser/services/browser.service';
import { Error } from 'app/core/error-handler/models';
import { createErrorRaised } from 'app/core/error-handler/state/actions';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { RouterRequest, RouterRequestActionType, RouterRequestFulfilled, RouterRequestRejected } from './actions';

@Injectable()
export class RouterRequestEffects {
  public source: string = 'RouterRequestEffects';

  @Effect()
  public navigate$: Observable<Action> = this._actions$
    .pipe(
      ofType(RouterRequestActionType.RouterRequest),
      switchMap(({ payload }: RouterRequest) => this._browserService.to(payload)),
      map((isActivated: boolean) => isActivated ?
        new RouterRequestFulfilled() : new RouterRequestRejected('')),
      catchError((err: any) => of(createErrorRaised(new Error({ message: err, source: this.source })))));

  @Effect()
  public navigateBack$: Observable<Action> = this._actions$
    .pipe(
      ofType(RouterRequestActionType.RouterBackRequest),
      tap(() => this._browserService.back()),
      map(() => new RouterRequestFulfilled()),
      catchError((err: any) => of(createErrorRaised(new Error({ message: err, source: this.source })))));

  @Effect()
  public navigateForward$: Observable<Action> = this._actions$
    .pipe(
      ofType(RouterRequestActionType.RouterForwardRequest),
      tap(() => this._browserService.forward()),
      map(() => new RouterRequestFulfilled()),
      catchError((err: any) => of(createErrorRaised(new Error({ message: err, source: this.source })))));

  constructor(
    private readonly _actions$: Actions,
    private readonly _browserService: BrowserService) { }
}
